/**
 * Labstep
 *
 * @module components/Comment/EmptyState
 * @desc Empty state for tag
 */

import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';

export const CommentEmptyState: React.FC = () => (
  <CardEmptyState
    src="/img/empty-state/comments.svg"
    title="No notes"
    explanation="Add any additional notes here and start a conversation about it with your collaborators. Click the + icon to attach images, files, tables, or longer text."
  />
);
